<template>
    <div class="Details">
    <section class="container">
        
              <b-message>
                <strong>Understand how the model is making decisions.</strong>. 

              </b-message>
        <div class="block">
             Generally, the model put weights on each word to make the decision. In the graphs below, high values on vertical axis mean that those words have a positive impact on model's decision and, conversely, low values have a negative impact.
        </div>
        <div class="columns" 
            v-for="(item, key) in classifier_weights" :key="item.id">
            <div class="column">
              <h2 class="title is-5">
               {{ key }}
              </h2>
              <div class="block">
                For the label {{ key }}, the most important words are <strong>
                  {{ item.features.slice(-3)[0] }},
                  {{ item.features.slice(-3)[1] }}
                  </strong> and 
                  <strong>{{ item.features.slice(-3)[2] }}
                  </strong>.
                <br>
                The less important words are <strong>
                  {{ item.features[0] }},
                  {{ item.features[1] }}
                  </strong> and
                  <strong>
                    {{ item.features[2] }}
                  </strong> 
              
              <Plotly :data="new Array({type:'bar', x: item.features, y: item.weights})" :display-mode-bar="false"></Plotly>
              </div>
            </div>
        </div>
        
    </section>

    </div>
</template>
<script>
import { Plotly } from 'vue-plotly'

   export default {
     props: ["boardId","model"],
     name: "Training",
     data: function() {
    return {
      weights: [],
      classifier_weights: []
    }},
    components: {
      Plotly
    },
     computed: {
       items() {
         return this.$store.state.currentModelItems;
       }
     },
     created() {

       this.weights = this.weights_report()
     },
      methods: {
        weights_report(){
          let weights = JSON.parse(this.model.predict.classifier_weights)
          this.classifier_weights = weights
          
          let keys = Object.keys(weights)

          let data = new Array();

          for(var i=0; i < weights.length; i++){
            
            data.push(
              new Array({title: keys[i], data: {
                 type: "bar", x: weights[i].features, y: weights[i].weights
              }})
            )
          }

          return data
        },
       columnTdAttrs(row, column) {
                if (row.first_name === 'Macro') {
                    if (column.label === 'Label') {
                        return {
                            class: 'has-text-weight-bold',
                        }
                    } else if (column.label === 'Accuracy') {
                        return {
                            class: 'has-text-weight-semibold'
                        }
                    } else {
                        return {
                            
                        }
                    }
                }
                return null
            },
       startTraining(){
        const model = {
           is_training: true,
           training_status: null
         }

         this.$store.dispatch("updateModel", {
          modelId: this.model.id,
          update: model
        });
       },
       updateTrainingStatus(){
         const model = {
           is_training: false
         }

         this.$store.dispatch("updateModel", {
          modelId: this.model.id,
          update: model
        });
       }
     }
   };
</script>